import Vue from 'vue';
import '@babel/polyfill';
import Cookies from 'js-cookie';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ZjUI from 'zhijiang-ui';
import 'zhijiang-ui/lib/css/zj-ui.css';
import IntroJs from 'intro.js';
import 'intro.js/introjs.css';
import '@/assets/css/base.css';
import '@/common/js/vuePrototype';
import '@/common/js/jsPrototype';
import '@/common/js/directive';

Vue.use(ElementUI);
Vue.use(ZjUI);
Vue.use(Cookies);

//引导
Vue.prototype.introJs = IntroJs();
Vue.prototype.introJs.setOptions({
  prevLabel: "上一步",
  nextLabel: "下一步",
  skipLabel: "跳过",
  doneLabel: "结束"
});
